import { render, staticRenderFns } from "./structure.vue?vue&type=template&id=898ed4ec&scoped=true"
import script from "./structure.vue?vue&type=script&lang=js"
export * from "./structure.vue?vue&type=script&lang=js"
import style0 from "./structure.vue?vue&type=style&index=0&id=898ed4ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898ed4ec",
  null
  
)

export default component.exports